// extracted by mini-css-extract-plugin
module.exports = {"shareMediaButtonWrapper":"_3VY2-","shareSocialMedia":"_3wGnP","text":"_2hFeU","titleShare":"z-9QW"};